import $ from 'jquery';
import axios from 'axios';
import { initializePaddle } from '@paddle/paddle-js';

const buyPaddleLicense = 'buy_paddle_license';
const isPaddleInlineRoute = window.location.href.indexOf('/paddle') !== -1;
const isPlansWithPaddleRoute = window.location.href.indexOf('/plans?' + buyPaddleLicense) !== -1;

const initUrl = '/rest/paddle/info/client-options';
const checkoutConfigUrl = '/rest/paddle/info/checkout-config/';

const mountInlineCheckout = async (licenseId) => {
    if (!licenseId) {
        return;
    }

    try {
        const initResponse = await axios.post(initUrl);
        const paddle = await initializePaddle({
            environment: initResponse.data.environment,
            token: initResponse.data.publicKey,
        });
        const { data = null } = await axios.get(checkoutConfigUrl + licenseId);

        paddle.Checkout.open(data.data);
    } catch (error) {
        console.log(error);
    }
};

export const paddleHandlers = () => {
    if (!isPaddleInlineRoute && !isPlansWithPaddleRoute) {
        return;
    }

    if (isPaddleInlineRoute) {
        mountInlineCheckout($('.checkout-container').data('licenseId'));

        return;
    }

    const params = new URLSearchParams(window.location.search);
    mountInlineCheckout(params.get(buyPaddleLicense));
};
